import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import Skills from "../Pages/Skills/Skills";
import Projects from "../Pages/Projects/Projects";
import AllProjects from "../Pages/Projects/AllProjectss";
import Contact from "../Pages/Contact/Contact";
import MainLayout from "../Layout/MainLayout";
import PageLayout from "../Pages/PageLayout/PageLayout";
import AllSkills from "../Pages/Skills/AllSkills";

const router = createBrowserRouter([
     {
       path: '',
       element: <Main />,
       children: [
         {
           path: '/',
           element: <PageLayout/>
         },
         {
           path: '/home',
           element: <Home></Home>
         },
         {
           path: '/about',
           element: <About></About>
         },
         {
           path: '/skills',
           element: <Skills></Skills>
         },
         {
           path: '/projects',
           element: <Projects></Projects>
         },
         {
           path: '/contact',
           element: <Contact></Contact>
         },
         {
           path: '/all-projects',
           element: <AllProjects/>,
         },
         {
           path: '/all-skills',
           element: <AllSkills/>,
         }
   
       ]
 
     }
   ])

   export default router;